<template>
    <div class="user_con_main">
        <div class="user_bill_top">
            <span class="user_bill_zzc">总资产：</span>
            <span class="user_bill_money" v-show="showjb">{{userrich.jb}}</span>
            <span class="user_bill_money" v-show="!showjb">***</span>
            <img src="../../assets/images/img2/eye_on.png" class="user_bill_eye" @click="showjb=!showjb" />
        </div>
        <div class="order" v-if="list">
            <img src="../../assets/images/no.png" alt="">
            <p class="fontC">暂无帐单~</p>
        </div>
        <div class="user_billlist" v-else>
            <div class="flex_bet user_billli" v-for="(item,index) in list" :key="index">
                <div class="flex_ali">
                    <img src="../../assets/images/bill_money.png" v-if="item.rctype == '1'" />
                    <img src="../../assets/images/bill_money.png2.png" v-else />
                    <div>
                        <!-- <p>购买作品</p> -->
                        <p class="user_bill_date">{{item.ctime}}</p>
                    </div>
                </div>
                <span class="user_bill_num">{{item.rmb}}</span>
            </div>
        </div>
        <div class="flex_aro_h">
            <el-pagination background layout="prev, pager, next" :total="total" @current-change="changeWoeks">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            page: 1, //分页页数
            list: [], //作品列表
            total: 0, //数据总数
            showjb: true, //是否现在总资产
        };
    },
    mounted() {
        this.getBillList();
    },
    computed: {
        ...mapState(["userrich"]),
    },
    methods: {
        // 分页点击事件
        changeWoeks(e) {
            this.page = e;
            this.getBillList();
            this.$globalFun.goTop();
        },
        // 获取我的账单
        getBillList() {
            let self = this;
            let json = {
                status: "1",
                page: this.page,
                rows: 10,
            };
            let url =
                self.$store.state.base_api +
                self.$store.state.base_url.qrycashrecharge;

            this.$request.postHttp(json, url, (decData) => {
                console.log(decData);
                self.list = decData.model.list;
                self.total = decData.model.total;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/view/user/user_bill.vue